const Careers = {
    "heroSection":{
        "title":"CAREERS",
        "subtext":"<strong>Ready to do the best work of your life?</strong> Then it’s you we’re after!"
    },
    "statistics": {
        "icons": true,
        "columns": 4,
        "stats": [
            {
                "icon": require('../svgs/healthy-environment.svg'),
                "content": "Healthy Environment"
            },
            {
                "icon": require('../svgs/good-infrastructure.svg'),
                "content": "Good Infrastructure"
            },
            {
                "icon": require('../svgs/team-spirit.svg'),
                "content": "Team Spirit"
            },
            {
                "icon": require('../svgs/gaming-zone.svg'),
                "content": "Gaming Zone"
            }
        ]
    },
    "textWithImage":{
        "content": "Come, be a part of our family, go on an adventure and lets do great things together!",
        "image": require('../images/about/about_img-1.jpg'),
        "button": {
            "text": "Apply job",
            "url": "",
            "class": "grad-orange quote apply-job"
        }
    },
    "carousal":{
        "subheading": "Life Inside Our Office",
        "title": "Diversity, entertainment & dedication",
        "images":[require('../images/careers/slide1.jpg'),require('../images/careers/slide3.jpg'),require('../images/careers/slide4.jpg'),require('../images/careers/slide5.jpg'),require('../images/careers/slide6.jpg'),require('../images/careers/slide7.jpg')]
    }
};

export default Careers;
